module.exports = __webpack_public_path__ + "img/caas1m-m@1.1c20dc48.webp";